import { HTTP_INTERCEPTORS, HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskModule } from 'ngx-mask';


import { NgxCurrencyModule } from 'ngx-currency';
import { ToastrModule } from 'ngx-toastr';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CopyrightComponent } from './copyright/copyright.component';
import { DealerLoginFormComponent } from './feature/dealer/authentication/dealer-login-form.component';
import { DealerResetPasswordComponent } from './feature/dealer/authentication/dealer-reset-password/dealer-reset-password.component';
import { DealerPanelComponent } from './feature/dealer/panel/dealer-panel.component';
import { DealerProfileComponent } from './feature/dealer/profile/dealer-profile.component';
import { DealerQueryReportsComponent } from './feature/dealer/query-reports/dealer-query-reports.component';
import { DealerReportLogComponent } from './feature/dealer/report/dealer-report-log.component';
import { DealerReportSearchComponent } from './feature/dealer/report-search/dealer-report-search.component';
import { DidNotPurchaseComponent } from './feature/dealer/report/did-not-purchase-modal/did-not-purchase.component';
import { PurchaseReceiptReportComponent } from './feature/dealer/report/purchase-receipt-report/purchase-receipt-report.component';
import {
  PurchaseReportCreationEditingComponent
} from './feature/dealer/report/purchase-report-creation-editing/purchase-report-creation-editing.component';
import { LogoutComponent } from './logout/logout.component';
import { NavigationComponent } from './navigation/navigation.component';
import { LicenseSearchModule } from './public-license-search/public-license-search.module';
import { RestApiInterceptor } from './rest-api-interceptor';
import { AppSettingsModule } from './shared/app-settings';
import { AutocompleteInputComponent } from './shared/autocomplete-input/autocomplete-input.component';
import { GlobalErrorHandlingModule } from './shared/global-error-handling';
import { DisplayNamePipe } from './util/display-name.pipe';
import { ToDatePipe } from './util/to-date.pipe';
import { BigCurrencyPipe } from './util/big-currency.pipe';
import { MultiplyBigPipe } from './util/multiply-big.pipe';
import { XhrInterceptor } from './xhr-interceptor';
import { QueryReportsResultTransactionComponent } from './feature/dealer/query-reports/result/transaction/query-reports-result-transaction.component';
import { AdminLoginFormComponent } from './feature/admin/authentication/admin-login-form.component';
import { AdminSearchComponent } from './feature/admin/search/admin-search.component';
import { AdminMainComponent } from './feature/admin/main/admin-main.component';
import { DataTableModule } from 'angular-6-datatable';
import { CookieService } from 'ngx-cookie-service';
import { AdminDealerInfoComponent } from './feature/admin/dealer-info/admin-dealer-info.component';
import { AdminDealerProfileComponent } from './feature/admin/dealer-info/dealer-profile/admin-dealer-profile.component';
import { AdminDealerReportLogComponent } from './feature/admin/dealer-info/dealer-report-log/admin-dealer-report-log.component';
import { AdminDealerQueryReportsComponent } from './feature/admin/dealer-info/dealer-query-reports/admin-dealer-query-reports.component';
import { AdminDealerReportSearchComponent } from './feature/admin/dealer-info/dealer-report-search/admin-dealer-report-search.component';
import { DealerProfileViewComponent } from './feature/dealer/profile/dealer-profile-view.component';
import { DealerReportLogViewComponent } from './feature/dealer/report/dealer-report-log-view.component';
import { DealerReportSearchViewComponent } from './feature/dealer/report-search/dealer-report-search-view.component';
import { DealerQueryReportsViewComponent } from './feature/dealer/query-reports/dealer-query-reports-view.component';
import { NgStickyModule } from 'ng-sticky';
import { PaperReportComponent } from './feature/admin/quick-add/paper-report/paper-report.component';
import { RequireAuthorityDirective } from './directives/require-authority/require-authority.directive';
import { CurrencyInputModule } from './directives/currency/currency.module';
import { DatatableKeyboardModule } from './directives/datatable-keyboard/datatable-keyboard.module';
import { PaperCreditComponent } from './feature/admin/quick-add/paper-credit/paper-credit.component';
import { QueryReportsResultSpeciesIndustryComponent } from '@app/feature/dealer/query-reports/result/species-industry/query-reports-result-species-industry.component';
import { MonthInputComponent } from './shared/month-input/month-input.component';
import { DisclaimerComponent } from './feature/disclaimer/disclaimer/disclaimer.component';
import { BulkUploadComponent } from './feature/admin/report/upload/bulkupload.component';
import { ConfirmationComponent } from './shared/confirmation/confirmation.component';


@NgModule({
  declarations: [
    AppComponent,
    DealerProfileComponent,
    DealerPanelComponent,
    DealerReportLogComponent,
    DealerReportSearchComponent,
    DealerQueryReportsComponent,
    DealerLoginFormComponent,
    LogoutComponent,
    NavigationComponent,
    CopyrightComponent,
    DidNotPurchaseComponent,
    PurchaseReportCreationEditingComponent,
    ToDatePipe,
    BigCurrencyPipe,
    MultiplyBigPipe,
    DealerResetPasswordComponent,
    AutocompleteInputComponent,
    DisplayNamePipe,
    PurchaseReceiptReportComponent,
    QueryReportsResultTransactionComponent,
    QueryReportsResultSpeciesIndustryComponent,
    AdminLoginFormComponent,
    AdminSearchComponent,
    AdminMainComponent,
    AdminDealerInfoComponent,
    AdminDealerProfileComponent,
    AdminDealerReportLogComponent,
    AdminDealerReportSearchComponent,
    DealerProfileViewComponent,
    PaperReportComponent,
    DealerReportLogViewComponent,
    DealerReportSearchViewComponent,
    AdminDealerQueryReportsComponent,
    DealerQueryReportsViewComponent,
    RequireAuthorityDirective,
    PaperCreditComponent,
    MonthInputComponent,
    DisclaimerComponent,
    BulkUploadComponent,
    ConfirmationComponent
  ],
  entryComponents: [
    PurchaseReportCreationEditingComponent,
    DidNotPurchaseComponent,
    DealerResetPasswordComponent,
    PurchaseReceiptReportComponent,
    QueryReportsResultTransactionComponent,
    QueryReportsResultSpeciesIndustryComponent,
    PaperReportComponent,
    PaperCreditComponent,
    ConfirmationComponent
  ],
  imports: [
    AppSettingsModule,
    AppRoutingModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    HttpClientXsrfModule,
    DataTableModule,
    DatatableKeyboardModule,
    NgbModule,
    NgxMaskModule.forRoot({

    }),
    ReactiveFormsModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-center'
    }),
    NgxCurrencyModule,
    LicenseSearchModule,

    // This module should be imported last.
    GlobalErrorHandlingModule,
    NgStickyModule,
    CurrencyInputModule
  ],
  providers: [
    NgbActiveModal,
    { provide: HTTP_INTERCEPTORS, useClass: XhrInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: RestApiInterceptor, multi: true },
    CookieService
  ],

  bootstrap: [AppComponent]
})
export class AppModule {
}
